module.exports = __webpack_public_path__ + "static/media/float1.9b5add48.png";